import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const IotAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.iot} />

export default IotAppDevelopment
